"use strict";

const MuniCleanoutDataListController = function () {
  var inited = false;
  var config = null;

  var init = function (reInitialize = false) {
    if (inited && !reInitialize) {
      render();
    } else {
      inited = true;
      config = {
        prepareDataCallback: _prepareCleanout,
        template: "list/muniCleanoutDataList.njk",
        layerName: "muniCleanout",
      };
      DataList.init(config);
      initialRender();
      loadListeners();
      DataList.loadDomListeners();
      DataList.loadDomListeners([{ target: ".open-fact-sheet", callback: openFactSheet }]);
    }
  };

  var loadListeners = function () {
    $(".data-list-container").off("click", ".map-button");
    $(".data-list-container").on("click", ".map-button", showMarkerOnMap);

    $(".data-list-container").off("click", ".open-hard-asset-inventory");
    $(".data-list-container").on(
      "click",
      ".open-hard-asset-inventory",
      HardAssetInventoryModalController.onOpenInventoryClick,
    );
  };

  var openFactSheet = function () {
    const id = DataList.getDataFromRow($(this)).id;
    UrlRoutes.go("cleanout-fact-sheet", { id });
    Analytics.sendDataListEvent("open_factsheet", "cleanouts");
  };

  var showMarkerOnMap = function () {
    var $tr = $(this).parents("tr");
    var id = $tr.data("id");

    MapFunctions.openPopupById(id);
    const mapButtonContainer = $(this).parents("td");
    DataList.addAnalyticsToMapIconOnAddress(mapButtonContainer.hasClass("address-col"));
  };

  var initialRender = function () {
    DataList.setSorting("name", false);
    render();
  };

  var render = function () {
    DataList.render(config);
  };

  var _prepareCleanout = function (muniCleanouts) {
    for (const cleanout of muniCleanouts) {
      cleanout.lastInspectionDate = cleanout.routine[cleanout.routine.length - 1];
      cleanout.lastInspectionDisplayDate = cleanout.lastInspectionDate
        ? DateTime.dateToGroupDisplayDate(cleanout.lastInspectionDate)
        : null;
    }
    sortMuniCleanoutsBy(muniCleanouts);

    return {
      rows: muniCleanouts,
      options: {},
    };
  };

  var sortMuniCleanoutsBy = function (muniCleanouts) {
    const alphaSorter = SortUtilities.alphaSorter;

    var sortersDict = {
      name: alphaSorter,
      address: alphaSorter,
      type: alphaSorter,
      cof: SortUtilities.cofSorter,
      coverShape: alphaSorter,
      lastInspectionDate: DateTime.dateComparator,
    };

    DataList.sortWithDict(muniCleanouts, sortersDict);
  };

  return {
    init,
  };
};

module.exports = MuniCleanoutDataListController();

const DataList = require("../mapFunctions/dataList");
const SortUtilities = require("../general/sortUtilities.js");
const MapFunctions = require("../mapFunctions/mapFunctions.js");
const UrlRoutes = require("../routes/urlRoutes");
const Analytics = require("../general/analytics");
const HardAssetInventoryModalController = require("./hardAssetInventoryModalController");
const DateTime = require("../dateTime");
